// extracted by mini-css-extract-plugin
module.exports = {"updateBioWrapper":"ManageBio_updateBioWrapper__VlqCy","updateBio":"ManageBio_updateBio__1Dh0z"};